import React from 'react';
import { Container, Heading } from '@charlietango/ui';
import { rem } from '../../styles/rem';

import { useAuth } from '../../api/AuthProvider';
import RichText from '../../components/RichText/RichText';
import { colors } from '../../styles/colors';
import { TextVariant } from '../../styles/typography';
import TextBlockViewModel from '../../view-models/TextBlockViewModel';

export type ArticleProps = {
  intro?: TextBlockViewModel;
  richText?: TextBlockViewModel;
};

function ArticlePage({ intro, richText }: ArticleProps) {
  const { loginUrl, logoutUrl } = useAuth();

  return (
    <>
      {(intro || richText?.text) && (
        <Container
          sx={{
            maxWidth: 'unset',
            mx: 0,
            px: [rem(20), rem(20), 0],
            py: [rem(80), rem(96), rem(120)],
            borderBottom: `1px solid rgba(31, 111, 111, 0.20)`,
          }}
        >
          <div sx={{ maxWidth: rem(952), mx: 'auto' }}>
            {intro?.title && (
              <Heading
                as="h1"
                variant={TextVariant.Header3xl}
                sx={{
                  mb: richText?.text ? [rem(16), rem(16), rem(20)] : undefined,
                  color: colors.base.Text.Primary,
                }}
              >
                {intro.title}
              </Heading>
            )}
            {richText?.text && (
              <RichText
                variant={TextVariant.BodyLg}
                params={{ loginUrl, logoutUrl }}
                sx={{
                  color: colors.base.Text.Primary,
                  maxWidth: rem(800),
                }}
              >
                {richText.text}
              </RichText>
            )}
          </div>
        </Container>
      )}

      {intro?.text && (
        <Container
          sx={{
            maxWidth: 'unset',
            mx: 0,
            px: [rem(20), rem(20), 0],
            py: [rem(64), rem(96), rem(120)],
          }}
        >
          <div sx={{ maxWidth: rem(952), mx: 'auto' }}>
            <RichText
              variant={TextVariant.BodyLg}
              params={{ loginUrl, logoutUrl }}
              sx={{
                color: colors.base.Text.Primary,
                maxWidth: rem(800),
                '> h2, > h3, > h4': {
                  color: colors.base.Text.Primary,
                },
                '> h2 + p, > h3 + p, > h4 + p': {
                  mt: 0,
                },
              }}
            >
              {intro.text}
            </RichText>
          </div>
        </Container>
      )}
    </>
  );
}

ArticlePage.displayName = 'ArticlePage';

export default ArticlePage;
